import React from 'react';
import VoucherRefListRow from './VoucherRefListRow'
import withView from '../../../cmn/docAutomation/withView';
import { UiViewContent } from "../../../../library/layout/Index";

const VoucherRefList = (props) => {
    const { formObject, viewData } = props;

    // console.log("voucher data", viewData);

    if (!viewData)
        return (null)

    return (
        <UiViewContent>
            <div className="uiSecContents">
                {
                    Object.values(viewData).map((row, index) => (
                        <VoucherRefListRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                    ))
                }
            </div>
        </UiViewContent>
    )
}

export default withView(VoucherRefList, "", "");